import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

@Injectable()
export abstract class MainLayoutAuthService {
  abstract userAuthenticated(): Observable<boolean>;
}

@Injectable()
export class FirebaseMainLayoutAuthService extends MainLayoutAuthService {
  userAuthenticated(): Observable<boolean> {
    return new Observable<boolean>((subscriber: Subscriber<boolean>) => {
      return onAuthStateChanged(getAuth(), (user) => subscriber.next(!!user));
    });
  }
}
